// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ── Selector box ── */
.custom-multi-select.ant-select-multiple .ant-select-selector {
  height: 42px !important;
  min-height: 42px !important;
  display: flex !important;
  align-items: center !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* ── Placeholder ── */
.custom-multi-select.ant-select-multiple .ant-select-selection-placeholder {
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  line-height: normal !important;
  height: auto !important;
  display: block !important;
  inset-inline-start: 11px !important;
  inset-inline-end: 11px !important;
}

/* ── Selected tags row ── */
.custom-multi-select.ant-select-multiple .ant-select-selection-overflow {
  flex-wrap: nowrap !important;
  align-items: center !important;
  height: 42px !important;
  overflow: hidden !important;
}

.custom-multi-select.ant-select-multiple .ant-select-selection-overflow-item {
  display: flex !important;
  align-items: center !important;
  max-height: 28px !important;
}

.custom-multi-select.ant-select-multiple .ant-select-selection-item {
  display: flex !important;
  align-items: center !important;
  height: 26px !important;
  line-height: 26px !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.custom-multi-select.ant-select-multiple .ant-select-selection-search {
  display: flex !important;
  align-items: center !important;
  height: 42px !important;
  margin-inline-start: 0 !important;
}

/* ── Dropdown arrow — positioned relative to .ant-select wrapper ── */
.custom-multi-select.ant-select {
  height: 42px !important;
}

.custom-multi-select.ant-select .ant-select-arrow {
  top: 50% !important;
  transform: translateY(-60%) !important;
  margin-top: 0 !important;
  inset-inline-end: 11px !important;
  height: auto !important;
  width: auto !important;
}

/* ── "Select All" option — set apart from the regular option list ── */
.custom-multi-select-all-option {
  font-weight: 700 !important;
  color: #155EEF !important;
  border-bottom: 1px solid #EAECF0 !important;
}

.custom-multi-select-all-option.ant-select-item-option-active {
  background-color: #EFF4FF !important;
}

.custom-multi-select-all-option.ant-select-item-option-selected {
  background-color: #EFF4FF !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Common/CustomSelect/CustomMultiSelect.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,uBAAA;AACA;EACI,uBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,yBAAA;EACA,4BAAA;AAEJ;;AACA,sBAAA;AACA;EACI,6BAAA;EACA,mBAAA;EACA,sCAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,mCAAA;EACA,iCAAA;AAEJ;;AACA,4BAAA;AACA;EACI,4BAAA;EACA,8BAAA;EACA,uBAAA;EACA,2BAAA;AAEJ;;AACA;EACI,wBAAA;EACA,8BAAA;EACA,2BAAA;AAEJ;;AACA;EACI,wBAAA;EACA,8BAAA;EACA,uBAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;AAEJ;;AACA;EACI,wBAAA;EACA,8BAAA;EACA,uBAAA;EACA,iCAAA;AAEJ;;AACA,sEAAA;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,mBAAA;EACA,sCAAA;EACA,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,sBAAA;AAEJ;;AACA,uEAAA;AACA;EACI,2BAAA;EACA,yBAAA;EACA,2CAAA;AAEJ;;AACA;EACI,oCAAA;AAEJ;;AACA;EACI,oCAAA;AAEJ","sourcesContent":["/* ── Selector box ── */\n:global(.custom-multi-select.ant-select-multiple .ant-select-selector) {\n    height: 42px !important;\n    min-height: 42px !important;\n    display: flex !important;\n    align-items: center !important;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n\n/* ── Placeholder ── */\n:global(.custom-multi-select.ant-select-multiple .ant-select-selection-placeholder) {\n    position: absolute !important;\n    top: 50% !important;\n    transform: translateY(-50%) !important;\n    line-height: normal !important;\n    height: auto !important;\n    display: block !important;\n    inset-inline-start: 11px !important;\n    inset-inline-end: 11px !important;\n}\n\n/* ── Selected tags row ── */\n:global(.custom-multi-select.ant-select-multiple .ant-select-selection-overflow) {\n    flex-wrap: nowrap !important;\n    align-items: center !important;\n    height: 42px !important;\n    overflow: hidden !important;\n}\n\n:global(.custom-multi-select.ant-select-multiple .ant-select-selection-overflow-item) {\n    display: flex !important;\n    align-items: center !important;\n    max-height: 28px !important;\n}\n\n:global(.custom-multi-select.ant-select-multiple .ant-select-selection-item) {\n    display: flex !important;\n    align-items: center !important;\n    height: 26px !important;\n    line-height: 26px !important;\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n\n:global(.custom-multi-select.ant-select-multiple .ant-select-selection-search) {\n    display: flex !important;\n    align-items: center !important;\n    height: 42px !important;\n    margin-inline-start: 0 !important;\n}\n\n/* ── Dropdown arrow — positioned relative to .ant-select wrapper ── */\n:global(.custom-multi-select.ant-select) {\n    height: 42px !important;\n}\n\n:global(.custom-multi-select.ant-select .ant-select-arrow) {\n    top: 50% !important;\n    transform: translateY(-60%) !important;\n    margin-top: 0 !important;\n    inset-inline-end: 11px !important;\n    height: auto !important;\n    width: auto !important;\n}\n\n/* ── \"Select All\" option — set apart from the regular option list ── */\n:global(.custom-multi-select-all-option) {\n    font-weight: 700 !important;\n    color: #155EEF !important;\n    border-bottom: 1px solid #EAECF0 !important;\n}\n\n:global(.custom-multi-select-all-option.ant-select-item-option-active) {\n    background-color: #EFF4FF !important;\n}\n\n:global(.custom-multi-select-all-option.ant-select-item-option-selected) {\n    background-color: #EFF4FF !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
